import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = 'https://backend.schnee.report/admin/login';

const Login = () => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const jwt = localStorage.getItem('jwt');
    const jwtTime = localStorage.getItem('jwtTime');
    
    if (jwt && jwtTime) {
      const tokenTime = new Date(jwtTime);
      const expiryTime = new Date(tokenTime.getTime() + 24 * 60 * 60 * 1000); // +24 hours
      const now = new Date();
      
      if (now < expiryTime) {
        navigate('/dashboard');
      }
    }
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post(API_URL, { email: identifier, password }, {
        headers: { 'Content-Type': 'application/json' }
      });
      localStorage.setItem('jwt', response.data.data.token);
      localStorage.setItem('jwtTime', new Date().toISOString());
      localStorage.setItem('uid', response.data.data.user.id);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.error?.message || 'Login fehlgeschlagen');
    }
  };

  const containerStyle: React.CSSProperties = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '20px'
  };

  const cardStyle: React.CSSProperties = {
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    padding: '48px 40px',
    maxWidth: '400px',
    width: '100%'
  };

  const logoContainerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '32px'
  };

  const logoStyle: React.CSSProperties = {
    maxWidth: '200px',
    height: 'auto'
  };

  const formStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  };

  const inputStyle: React.CSSProperties = {
    padding: '14px 16px',
    fontSize: '16px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    outline: 'none',
    transition: 'all 0.3s ease',
    fontFamily: 'inherit'
  };

  const buttonStyle: React.CSSProperties = {
    padding: '14px 16px',
    fontSize: '16px',
    fontWeight: '600',
    color: 'white',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    marginTop: '8px'
  };

  const errorStyle: React.CSSProperties = {
    color: '#d32f2f',
    fontSize: '14px',
    padding: '12px',
    backgroundColor: '#ffebee',
    borderRadius: '8px',
    textAlign: 'center'
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={logoContainerStyle}>
          <img src="/SchneeReport_Logo.png" alt="SchneeReport Logo" style={logoStyle} />
        </div>
        <form onSubmit={handleSubmit} style={formStyle}>
          <input
            type="text"
            placeholder="Email oder Benutzername"
            value={identifier}
            onChange={e => setIdentifier(e.target.value)}
            required
            style={inputStyle}
            onFocus={(e) => e.target.style.borderColor = '#667eea'}
            onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
          />
          <input
            type="password"
            placeholder="Passwort"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            style={inputStyle}
            onFocus={(e) => e.target.style.borderColor = '#667eea'}
            onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
          />
          <button
            type="submit"
            style={buttonStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(102, 126, 234, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Anmelden
          </button>
          {error && <div style={errorStyle}>{error}</div>}
        </form>
      </div>
    </div>
  );
};

export default Login;